import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { generateRandomKey } from '../utils';

import classes from './BreadCrumbs.module.css';

const BreadCrumbs = (props) => {
  const { breadCrumbs, containerClassName, listClassName, lastUpdatedDate } = props;

  return (
    breadCrumbs && (
      <div
        className={classNames(
          classes.locationBreadcrumbs,
          `locationBreadcrumbs p-0 m-0 ${containerClassName} ${lastUpdatedDate ? 'row' : ''}`
        )}
      >
        <ul
          className={`breadcrumb custom-breadcrumb ${
            lastUpdatedDate ? 'col-12 col-lg-9 order-last order-lg-first' : ''
          } ${listClassName}`}
        >
          {breadCrumbs.map(({ text, link }) => (
            <li key={generateRandomKey()}>{link ? <a href={link}>{text}</a> : text}</li>
          ))}
        </ul>
        {lastUpdatedDate && (
          <div
            itemProp="dateModified"
            className="col-12 col-lg-3 order-first order-lg-last pl-0 pr-0 mb-3 mb-lg-0 average-salary-text last-updated-date"
          >
            {`Updated ${lastUpdatedDate}`}
          </div>
        )}
      </div>
    )
  );
};

BreadCrumbs.defaultProps = {
  breadCrumbs: [],
  containerClassName: '',
  listClassName: '',
  lastUpdatedDate: '',
};

BreadCrumbs.propTypes = {
  breadCrumbs: PropTypes.array.isRequired,
  containerClassName: PropTypes.string,
  listClassName: PropTypes.string,
  lastUpdatedDate: PropTypes.string,
};

export default BreadCrumbs;
